import { motion } from "framer-motion";
import { ClickablePlayer } from "../player/ClickablePlayer.jsx";

export function NightEventLog({ log, players, lang }) {
  const t = (fr, en) => lang === "fr" ? fr : en;
  if (!log || log.length === 0) return null;

  const getPlayer = (id) => players.find(p => p.id === id);

  const CP = ({ id }) => {
    const p = getPlayer(id);
    return p
      ? <ClickablePlayer player={p} className="text-amber-300" />
      : <span>{getPlayer(id)?.name || "?"}</span>;
  };

  const renderEvent = (evt, i) => {
    let icon, color, body;
    switch (evt.type) {
      case "peaceful_night":
        icon="🌿"; color="border-emerald-800/40 bg-emerald-950/30";
        body=<span>{t("Nuit paisible. Personne n'est mort.","Peaceful night. Nobody died.")}</span>; break;
      case "wolf_kill":
        icon="🐺"; color="border-red-800/40 bg-red-950/30";
        body=<span>{t("Les Loups-Garous ont tué ","The Werewolves killed ")}<CP id={evt.victimId}/>{t(".",".")}</span>; break;
      case "wolf_protected":
        icon="🛡️"; color="border-blue-800/40 bg-blue-950/30";
        body=<span><CP id={evt.victimId}/>{t(" a été attaqué·e par les loups mais protégé·e."," was attacked by the Werewolves but protected.")}</span>; break;
      case "sheep_protected":
        icon="🐑"; color="border-stone-600/40 bg-stone-800/30";
        body=<span>{t("Les Loups ont attaqué ","The Werewolves attacked ")}<CP id={evt.victimId}/>{t(", mais un mouton a été sacrifié à sa place."," , but a sheep was sacrificed in their place.")}</span>; break;
      case "fox_lost_power":
        icon="🦊"; color="border-orange-700/40 bg-orange-950/30";
        body=<span>{t("Le Renard s'est installé paisiblement au village.","The Fox settled peacefully in the village.")}</span>; break;
      case "bbw_kill":
        icon="🐗"; color="border-rose-800/40 bg-rose-950/30";
        body=<span>{t("Le Grand Méchant Loup a éliminé ","The Big Bad Wolf eliminated ")}<CP id={evt.victimId}/>{t(".",".")}</span>; break;
      case "ww_kill":
        icon="🤍"; color="border-slate-700/40 bg-slate-900/30";
        body=<span>{t("Le Loup Blanc a éliminé ","The White Werewolf eliminated ")}<CP id={evt.victimId}/>{t(".",".")}</span>; break;
      case "elder_extra_life":
        icon="🧓"; color="border-yellow-700/40 bg-yellow-950/30";
        body=<span><CP id={evt.victimId}/>{t(" (l'Ancien) a survécu à l'attaque grâce à sa vie supplémentaire."," (the Elder) survived the attack using their extra life.")}</span>; break;
      case "witch_save":
        icon="🧪"; color="border-violet-800/40 bg-violet-950/30";
        body=<span>{t("La Sorcière a utilisé sa potion de vie sur ","The Witch used the life potion on ")}<CP id={evt.victimId}/>{t(".",".")}</span>; break;
      case "witch_save_success":
        icon="🧪"; color="border-emerald-700/40 bg-emerald-950/30";
        body=<span>{t("La Sorcière a sauvé ","The Witch saved ")}<CP id={evt.victimId}/>{t(" avec sa potion de vie."," with the life potion.")}</span>; break;
      case "witch_save_wasted":
        icon="🧪"; color="border-stone-700/40 bg-stone-900/30";
        body=<span>{t("La Sorcière a tenté de sauver ","The Witch attempted to save ")}<CP id={evt.victimId}/>{t(", mais la victime n'était pas en danger. Potion non consommée.",", but the victim was never at risk. Potion not consumed.")}</span>; break;
      case "witch_poison":
        icon="☠️"; color="border-purple-800/40 bg-purple-950/30";
        body=<span>{t("La Sorcière a empoisonné ","The Witch poisoned ")}<CP id={evt.victimId}/>{t(".",".")}</span>; break;
      case "infection":
        icon="🦠"; color="border-purple-800/40 bg-purple-950/30";
        body=<span><CP id={evt.victimId}/>{t(" a été infecté·e par le Loup Père Infect et rejoint secrètement les loups."," was infected by the Father of Wolves and secretly joined the Werewolves.")}</span>; break;
      case "infection_failed_protected":
        icon="🦠"; color="border-stone-700/40 bg-stone-900/30";
        body=<span>{t("Le Père Infect a tenté d'infecter ","The Father attempted to infect ")}<CP id={evt.victimId}/>{t(", cible protégée. Pouvoir non consommé.",", but the target was protected. Ability not consumed.")}</span>; break;
      case "lover_death":
        icon="💔"; color="border-pink-800/40 bg-pink-950/30";
        body=<span><CP id={evt.victimId}/>{t(" est mort·e de chagrin car son amoureux·se "," died of heartbreak because their lover ")}<CP id={evt.partnerId}/>{t(" est mort·e."," died.")}</span>; break;
      case "hunter_shot":
        icon="🏹"; color="border-amber-800/40 bg-amber-950/30";
        body=<span>{t("Le Chasseur a abattu ","The Hunter shot ")}<CP id={evt.victimId}/>{t(" dans son dernier souffle."," with their last breath.")}</span>; break;
      case "execution":
        icon="⚖️"; color="border-amber-800/40 bg-amber-950/30";
        body=<span>{t("Le village a voté pour éliminer ","The village voted to eliminate ")}<CP id={evt.victimId}/>{t(".",".")}</span>; break;
      case "bear_growls":
        icon="🐻"; color="border-orange-800/40 bg-orange-950/30";
        body=<span>{t("L'ours grogne ! Un voisin du Montreur d'Ours est Loup-Garou.","The bear growls! A neighbor of the Bear Tamer is Werewolf-aligned.")}</span>; break;
      case "bear_calm":
        icon="🐻"; color="border-emerald-800/40 bg-emerald-950/30";
        body=<span>{t("L'ours reste calme. Aucun voisin n'est un Loup.","The bear is calm. No neighbor is a Werewolf.")}</span>; break;
      case "wild_child_turned":
        icon="🧒"; color="border-lime-800/40 bg-lime-950/30";
        body=<span>{t("L'Enfant Sauvage a perdu son modèle et rejoint secrètement les Loups.","The Wild Child's role model died. They secretly joined the Werewolf side.")}</span>; break;
      case "elder_penalty":
        icon="🧓"; color="border-yellow-800/40 bg-yellow-950/30";
        body=<span>{t("L'Ancien est mort ! Tous les pouvoirs spéciaux du Village sont perdus.","The Elder has died! All Village special powers are permanently lost.")}</span>; break;
      default:
        return null;
    }
    return (
      <motion.div key={i}
        initial={{ opacity:0, x:-16 }}
        animate={{ opacity:1, x:0, transition:{ delay: i * 0.1 } }}
        className={`flex items-start gap-3 rounded-2xl p-3 border ${color}`}>
        <span className="text-xl shrink-0 mt-0.5">{icon}</span>
        <p className="text-amber-100/90 text-sm leading-snug">{body}</p>
      </motion.div>
    );
  };

  return (
    <div className="flex flex-col gap-2">
      {log.map((evt, i) => renderEvent(evt, i))}
    </div>
  );
}
